/**
 * @description 接口相关配置
 */

const statusMap = {
  SUCCESS: 0, //成功
  NOT_LOGIN: 2,
}

const errnoMap = {
  SUCCESS: 0,
}

export {
  statusMap,
  errnoMap,
}
